import template from "./bModalVideo.html";

export function bModalVideoDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    scope: {
      source: "=",
      visibility: "=",
      user: "="
    },
    controller: bModalVideoController,
    controllerAs: 'bModalVideo',
    bindToController: true
  };

  return directive;
}

class bModalVideoController {
  constructor (Work) {
    'ngInject';

    this.Work = Work;

    this.video = document.getElementById('videoPlayer');
    this.loading = true;

    this.timeout = setTimeout(() => {
      this.loading = false;
      this.video.play();
    }, 2000);

    this.video.addEventListener('ended',() => {
      this.stopAndClose();
    }, false);

    this.video.addEventListener('play',() => {
      this.videoLastStartTime = this.video.currentTime;
    }, false);
  }

  stopAndClose() {
    this.Work.fireAndForgetMetric({ type: "STATS_VIDEO", videoStopTime: this.video.currentTime, videoStartTime: this.videoLastStartTime, videoDuration: this.video.duration, fullName: this.user.fullName });
    this.video.pause();
    this.video.currentTime = 0;
    this.visibility = false;
    clearTimeout(this.timeout);
  }

  onVideoHover() {
    this.video.setAttribute('controls', 'true');
  }

  onVideoLeave() {
    this.video.removeAttribute('controls');
  }
}
